import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { ShowMoreIcon } from '@kvdbil/components';

interface Props {
  isExpanded: boolean;
}

const Container = styled.div<{ isExpanded: boolean }>`
  display: flex;
  align-items: center;

  svg {
    font-size: 1.15rem;
    transition: 250ms;
    transform: ${props => (props.isExpanded ? 'rotate(180deg)' : 'rotate()')};
  }
`;

const ToggleArrow = ({ isExpanded }: Props): ReactElement => {
  return (
    <Container isExpanded={isExpanded}>
      <ShowMoreIcon />
    </Container>
  );
};

export default ToggleArrow;
